import React, { Component } from "react";

import Authentication from "../Containers/AuthenticationContainer.js";
import SearchContainer from "../Containers/SearchContainer.js";
import ServerSearchContainer from "../Containers/ServerSearchContainer.js";
import { withTranslation } from 'react-i18next';

class Header extends Component {
	constructor(props) {
        super(props);
    }
	
	dropdownclick(){
		this.setState({desplegat: !this.state.desplegat});
	}
	
	handleMaxorders(e){
		let val = parseInt(e.target.value, 10);
		this.setState({maxorders: val});
	}
	
	//style={{ height:"100%"}}
	render(){
		const { t } = this.props;
		var logout="";
		var search="";
		var serverSearch="";
		//Multiplataforma
		let title="";
		let logo="";
		let cssPrefix="";
		
		if(this.props.isLoggedIn){
			logout = <Authentication/>
			search = <SearchContainer/>
			//serverSearch = <ServerSearchContainer/>
		}else{
			logout="";
			search = "";
			//serverSearch = "";
		}
		
		switch (this.props.multiplataforma) {
			case 'indra':
				title = 'INDRA Translation Services';
				logo = '/img/logoIndra.png';
				cssPrefix = 'indra-'
				break;
			case 'networkia':
				title = 'NETWORKIA Translation Services';
				logo = '/img/logoNetworkia.png';
				cssPrefix = 'networkia-'
				break;
			case 'devecl':
			default:
				title = t('translation_services');
				logo = '/img/logo.png';
				cssPrefix = "";
		}
	
		return (
			<div className={`row g-0 justify-content-md-center align-items-center ${cssPrefix}page-header`}>
				<div className="col-md-2 d-none d-md-block">
					<div className={`${cssPrefix}page-logo`}><a href="/"><img src={logo} alt="logo" className="logo-default" /></a></div>
				</div>
				<div className="col-md-6">
					<div style={{fontFamily: "Lato", fontSize: "21px", color: "#fff", textAlign: 'center'}}>{title}</div>
				</div>
				<div className="col-md-2">
					<div className="row">{logout}</div>
					<div className="row">{search}</div>
				</div>
			</div>
		)
	}
}

export default withTranslation()(Header);